export const LOCATIONS = "locations";
export const LOCATION_ID = "location_id";



// WEBPACK FOOTER //
// ./app/modules/Locations/constants.js